export class ProduktvalTableTexts {
// eslint-disable-next-line sonarjs/public-static-readonly
    static texts = {
        redigera: "Redigera",
        pinar: "PIN(ar)",
        medTillUtbytessimulering: "Till utbyte",
        utbyteInfoText: "Vald PIN används i utbyte/simulering (egen skog)",
        simuleradVolym: "Simulerad volym",
        simuleradVolymInfo: "Utbytessimulerad volym",
        emptyTreeSelectorText: "Inga handelssortiment",
        kontrakteradVolymText: "Kontrakterad volym",
        tableHeaders: {
            handelssortiment: "Handelssortiment",
            produkt: "Produkt",
            pin: "PIN",
            medTillUtbytessimulering: "Till utbyte"
        }
    };
}
